// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__LnZW5","cell":"ColumnAccessor_cell__2Uynv","firstCellAccent":"ColumnAccessor_firstCellAccent__2EglZ"};